module.exports = __webpack_public_path__ + "assets/fonts/GothamRnd-BookIta.f430aca0.otf";